class Display {
  value;
  style;

  constructor(value = "", style = "") {
    this.value = value;
    this.style = style;
  }
}

class TableHeader {
  constructor(display = "", style = "", sortProperty = null) {
    this.display = new Display(display, style);
    this.sortProperty = sortProperty;
  }
}

export default TableHeader;
